import { Siret } from "../shared/Siret";

export default {
  // On transforme le Siret brut reçu en siren
  extractSiren(
    sirets: Siret[],
    restaurantID: number | string
  ): string | undefined {
    const siretObj = sirets.find(
      (s: Siret) => s.restaurantId.toString() === restaurantID.toString()
    );

    if (siretObj) {
      const siretLibelle = siretObj.libelle.replace(/\s+/g, "");
      return siretLibelle.substring(0, 9);
    }

    return "";
  },
};
